(function () {
  "use strict";

  const button = document.getElementById("submit-button");
  const contactForm = document.getElementById("contact-form");
  const contactFormContainer = document.getElementById("contact-form-container");
  const successMessage = document.createElement("div");
  const errorMessage = document.createElement("div");
  const formElements = contactForm.querySelectorAll("input, textarea, button");
  successMessage.textContent =
    "Thank you for your message. We will respond to you shortly.";
  errorMessage.textContent =
    "Sorry, there was an issue sending your message. Please check that all fields are complete and try again.";
  successMessage.classList.add("pt-8", "text-lg");
  errorMessage.classList.add("pt-8", "text-red-900");

  // event triggered by ReCAPTCHA when user passes test
  const onRecaptchaSuccess = function () {
    console.debug("enabling submit button");
    button.disabled = false;
  };

  function setFormDisabled(disabled) {
    console.debug(`Disable form: ${disabled}`);
    formElements.forEach(el => (el.disabled = disabled));
  }

  function onRecaptchaError() {
    contactForm.parentElement.appendChild(errorMessage);
    contactForm.remove();
  }

  async function getPublicKey() {
    const res = await fetch("/RepositorySite/retrievePublicKey");
    const json = await res.json();
    const key = json.publicKey;
    return key;
  }

  window.onloadCallback = async function () {
    try {
      const publicKey = await getPublicKey();
      grecaptcha.render("g-recaptcha", {
        sitekey: publicKey,
        callback: onRecaptchaSuccess,
        "error-callback": onRecaptchaError
      });
    } catch (e) {
      console.error(e);
      // contact form would not function, so removing it
      contactFormContainer.remove();
    }
  };

  async function submit(e) {
    e.preventDefault();
    setFormDisabled(true);
    if (contactForm.contains(errorMessage)) {
      contactForm.removeChild(errorMessage);
    }
    const form = e.currentTarget;

    // NOTE: after adding recaptcha, using new FormData(e.currentTarget) did
    // not work as expected. Not sure why it interferes. Manually creating data
    // object instead.
    const data = {
      name: form.querySelector("[name='name']").value,
      email: form.querySelector("[name='email']").value,
      organization: form.querySelector("[name='organization']").value,
      comments: form.querySelector("[name='comments']").value,
      "g-recaptcha-response": form.querySelector(
        "[name='g-recaptcha-response']"
      ).value
    };

    try {
      const res = await fetch("/RepositorySite/contactUs", {
        method: "POST",
        body: new URLSearchParams(data),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      if (res.ok) {
        // TODO handle success
        contactForm.parentElement.appendChild(successMessage);
        contactForm.remove();
      } else {
        // TODO something more specific
        setFormDisabled(false);
        contactForm.appendChild(errorMessage);
        throw new Error("Error submitting contact form");
      }
    } catch (e) {
      console.error(e);
      // TODO handle error
    }
  }

  contactForm.addEventListener("submit", submit);
})();
